<div class="defaultBox">
  <div class="defaultBox__col-wrap">
    <div class="defaultBox__col">
      <div class="defaultBox__sell-big"></div>
      <div class="defaultBox__sell-small"></div>
      <div class="defaultBox__sell-small"></div>
    </div>
    <div class="defaultBox__col">
      <div class="defaultBox__sell-big"></div>
      <div class="defaultBox__sell-small"></div>
      <div class="defaultBox__sell-small"></div>
    </div>
    <div class="defaultBox__col">
      <div class="defaultBox__sell-big"></div>
    </div>
    <div class="defaultBox__col">
      <div class="defaultBox__sell-big"></div>
      <div class="defaultBox__sell-big"></div>
    </div>
  </div>
  <div class="defaultBox__sell-long"></div>
</div>
